import { Colors } from "@styles/colors";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { MarkObj } from "rc-slider/lib/Marks";
import React from "react";
import { handleRender } from "./TooltipSlider";

export const PricingSlider = ({
    onChange,
    onBlur,
    minimumQuantity,
    maximumQuantity,
    assessmentQuantity,
    marks
}: PricingSliderProps): JSX.Element => {
    return (
        <div className="columns minw-100 ml-6 pt-6 is-align-items-center">
            <div className="column is-10 mb-5 pb-4">
                <Slider
                    min={minimumQuantity}
                    max={maximumQuantity}
                    handleRender={handleRender}
                    onChange={onChange}
                    included
                    defaultValue={assessmentQuantity}
                    value={assessmentQuantity}
                    marks={marks}
                    trackStyle={{ backgroundColor: "#3C6FB0", height: 10 }}
                    handleStyle={{
                        borderColor: "#3C6FB0",
                        height: 28,
                        width: 28,
                        marginLeft: -14,
                        marginTop: -9,
                        backgroundColor: "#3C6FB0",
                        opacity: 1
                    }}
                    railStyle={{ backgroundColor: "#D8E4EB", height: 10 }}
                    dotStyle={{ opacity: 0 }}
                />
            </div>
            <div className="column is-2 ml-5">
                <input
                    value={assessmentQuantity}
                    className="mw-50 p-3 has-text-centered has-text-weight-semibold is-size-6"
                    style={{ border: `1px solid ${Colors.primaryBlue}`, borderRadius: "12px" }}
                    onChange={(e) => onChange(Number(e.target.value))}
                    onBlur={onBlur}
                    type="text"
                    inputMode="numeric"
                    min={minimumQuantity}
                    max={maximumQuantity}
                />
                <p>assessments</p>
            </div>
        </div>
    );
};

interface PricingSliderProps {
    onChange: (newValue: number | number[]) => void;
    onBlur?: () => void;
    marks: Record<string | number, React.ReactNode | MarkObj> | undefined;
    assessmentQuantity: number;
    defaultAssessmentQuantity: number;
    minimumQuantity: number;
    maximumQuantity: number;
}
